/** Words for the step-up 2FA dialog (src/api/stepup.py purposes `<group>.<action>`). */

const PURPOSES: Record<string, string> = {
  'admins.create': 'Добавить администратора',
  'admins.create_password': 'Создать администратора с паролем и 2FA',
  'admins.update': 'Изменить роль или доступ администратора',
  'payouts.approve': 'Одобрить выплату партнёру',
  'payouts.retry': 'Повторить выплату партнёру',
  'payouts.return': 'Вернуть сумму выплаты на баланс партнёра',
  refund: 'Вернуть платёж',
  credit: 'Ручное начисление или списание кредитов',
  'accounting.partner_create': 'Добавить совладельца и его долю',
  'accounting.partner_update': 'Изменить долю совладельца',
  'accounting.partner_delete': 'Удалить совладельца',
  'accounting.distribution_approve': 'Утвердить распределение прибыли',
  'gateways.sbp': 'Изменить порядок платёжных шлюзов СБП',
  'flags.kill': 'Переключить аварийный выключатель',
  'webhooks.reprocess': 'Повторно обработать событие провайдера',
}

/** The dialog body for a purpose; an unknown one still gets a sensible sentence. */
export function stepUpBody(purpose: string | null): string {
  const what = purpose ? PURPOSES[purpose] : undefined
  return what
    ? `${what}: опасное действие, подтвердите его кодом из приложения-аутентификатора.`
    : 'Опасное действие: подтвердите его кодом из приложения-аутентификатора.'
}
